import findModelAovId from 'schemas/migrator/helpers/findModelAovId'
import { stringToBoolean } from './general'

export default async (enabled, selectedModel) => {
  if (!stringToBoolean(enabled) || !selectedModel) return {}
  const cameraModels = await import(/* webpackChunkName: "migratorModels", webpackPrefetch: true */ 'schemas/migrator/cameraModels.json').then(res => res.default || res)

  const model = cameraModels.find(m => m.model === selectedModel.model && m.manufacturer === selectedModel.manufacturer)
  if (!model) {
    console.log(`MODEL NOT FOUND: ${selectedModel.model}`)
    return {}
  }
  return {
    modelId: model.id,
    ...findModelAovId(model, selectedModel)
  }
}



// WEBPACK FOOTER //
// ./src/schemas/migrator/helpers/cameraModelInfo.js